import { ObjectOrArray, ThemeBorders, ThemeBorderWidths } from "styled-system";
import * as CSS from "csstype";
import { ThemeBorderStyles } from "styled-system";

export const bordersMap: ThemeBorders = {
	none: 0,
	'1px': '1px solid',
	'2px': '2px solid',
	'4px': '4px solid',
	'8px': '8px solid',
};

export const borderWidthsMap: ThemeBorderWidths = {

};

export const borderStylesMap: ThemeBorderStyles = {

};


// export const borders: ObjectOrArray<CSS.Property.Border, keyof ThemeBorders> = []

// export const borderWidths: ObjectOrArray<CSS.Property.BorderWidth, keyof ThemeBorderWidths> = [];

// export const borderStyles: ObjectOrArray<CSS.Property.BorderStyle, keyof ThemeBorderStyles> = [];

